import React from 'react';
import { Dropdown, Menu } from 'antd';
import styles from './CustomTag.module.scss';
import { useTranslation } from 'next-i18next';

export type TagProps = {
  title: string;
  icon: JSX.Element;
  type: string;
  updateStatus: (value: boolean) => void;
};

const CustomTag: React.FC<TagProps> = ({ title, type, icon, updateStatus }) => {
  const { t: translate } = useTranslation(['position']);

  const changeStatusMenu = (
    <Menu mode="vertical">
      <Menu.Item key="open" onClick={() => updateStatus(true)} className="main-body-text" data-testid="open-option">
        {translate('open')}
      </Menu.Item>
      <Menu.Item
        key="closed"
        onClick={() => updateStatus(false)}
        className="main-body-text"
        data-testid="closed-option"
      >
        {translate('closed')}
      </Menu.Item>
    </Menu>
  );

  return type === 'published' ? (
    <Dropdown dropdownRender={() => changeStatusMenu} trigger={['click']} placement="bottomRight" arrow>
      <div className={styles[type]} data-testid="public-tag-dropdown">
        <div className={styles.tagIcon}>{icon}</div>
        <h6 className={`main-body-text ${styles.tagTitle}`}>{title}</h6>
      </div>
    </Dropdown>
  ) : (
    <div className={styles[type]}>
      <div className={styles.tagIcon}>{icon}</div>
      <h6 className={`main-body-text ${styles.tagTitle}`}>{title}</h6>
    </div>
  );
};

export default CustomTag;
